import React from "react";

const PreviewAudio = React.forwardRef(function PreviewAudio({ file }, ref) {
  return <audio ref={ref} src={file.url} controls="controls" />;
});

PreviewAudio.DefaultActions = () => null;

export default PreviewAudio;
